/* Find Your Case page behaviour. Markup: sections/fyc-page.liquid
 * Pill counts: Case Specs in Shopify admin, via assets/ikg-case-sizes.js (window.IKG_SIZES).
 * Prices, stock and variant ids: read live from Shopify (window.FYC_DATA).
 */
(function () {
  var root = document.getElementById('fyc');
  if (!root) return;
  var D = window.FYC_DATA || { img: {}, sizes: {}, magnanoSet: {}, fourWeekSet: {} };
  // No pill-count data on the page: show nothing rather than wrong sizes, and say why in the console.
  if (!window.IKG_SIZES || !window.IKG_SIZES.ok) {
    root.hidden = true;
    if (window.console) console.error('Find Your Case: no Case Specs pill counts (snippets/case-specs-data.liquid / assets/ikg-case-sizes.js). Finder hidden.');
    return;
  }

  // kind: 'variant' = standard product (?variant= link), 'magnano' = MagNano builder (?pockets=&size=),
  // 'fourweek' = Magnetic Set builder (?count=4; size is picked on the page).
  var P = [
    { id: 'weekly', h: 'weekly-case', name: 'Weekly Case', line: 'Fill it once a week. Open one day at a time.', often: 'Once a day', type: 'One case', holds: '7 days', best: 'Home or travel', kind: 'variant', bundle: true },
    { id: 'ampm', h: 'weekly-ampm-case-2-0', name: 'Weekly AM-PM', line: 'A morning and a night pocket for every day.', often: 'Morning + night', type: 'AM + PM pair', holds: '7 days', best: 'Home or travel', kind: 'variant', bundle: true },
    { id: 'magnano', h: 'magnano-case', name: 'MagNano', line: 'Seven magnetic days. Grab one and go.', often: 'Once a day', type: 'Magnetic days', holds: '7 days', best: 'Grab a day and go', kind: 'magnano', pockets: 1, unit: 'set of 7' },
    { id: 'magampm', h: 'magnano-am-pm-case', name: 'MagNano AM-PM', line: 'Morning and night pockets on every magnetic day.', often: 'Morning + night', type: 'Magnetic days', holds: '7 days', best: 'Grab a day and go', kind: 'magnano', pockets: 2, unit: 'set of 7' },
    { id: 'mission', h: 'mission-case', name: 'Mission Case', line: 'Compact for a bag or carry-on.', often: 'As needed', type: 'One case', holds: '3 pockets', best: 'Travel', kind: 'variant', bundle: true },
    { id: 'nano', h: 'nano-case', name: 'Nano Case', line: 'Our smallest case, for a pocket or bag.', often: 'As needed', type: 'One case', holds: '1 pocket', best: 'Pocket or bag', kind: 'variant', bundle: true },
    { id: 'twoweek', h: '2-week-case-2-0', name: '2-Week Case', line: 'Two magnetic weeks that snap together. Fill once every two weeks.', often: 'Once a day', type: 'Magnetic weeks', holds: '14 days', best: 'Filling two weeks ahead', kind: 'variant', bundle: true, multi: true },
    { id: 'fourweek', h: '4-week-magnetic-set', name: '4-Week Set', line: 'Four magnetic weeks that snap together. Fill once a month.', often: 'Once a day', type: 'Magnetic weeks', holds: '28 days', best: 'Filling a month ahead', kind: 'fourweek', multi: true }
  ];

  // Sizes and pill counts come from assets/ikg-case-sizes.js, which reads Case Specs in Shopify.
  // No pill count is ever typed into this file. Sizes without counts (or not released) are in UNPUB.
  var SZ = window.IKG_SIZES.sizes;
  var UNPUB = window.IKG_SIZES.unpub;
  // If a dose is too big for every size of a case, the case to suggest instead (same routine).
  var UP = { nano: 'mission', magnano: 'weekly', magampm: 'ampm' };

  // [name, everyday examples]. Advil is the small pill in our storage photos; fish oil softgels are the XL.
  var PILL = [['Small', 'Advil, baby aspirin'], ['Medium', 'Tylenol caplets, Excedrin'], ['Large', 'Multivitamins, calcium'], ['XL', 'Fish oil, gummy vitamins']];
  var MAXQ = 30;

  var BY = {}; P.forEach(function (p) {
    BY[p.id] = p;
    p.sizes = (SZ[p.id] || []).map(function (q) { return q.n; }).concat(UNPUB[p.id] || []).join(', ');
  });
  var Q = [
    ['often', 'How often do you take your pills?', [['once', 'Once a day'], ['twice', 'Morning and night'], ['thrice', '3 times a day'], ['needed', 'Only when needed']]],
    ['fill', 'How far ahead do you fill your case?', [['day', 'One day'], ['week', 'One week'], ['two', 'Two weeks'], ['month', 'A month']]],
    ['where', 'Where do your pills go?', [['home', 'They stay at home'], ['out', "I take a day's pills out with me"], ['travel', 'I travel a lot']]]
  ];
  function asked(key) { return key !== 'fill' || (s.often === 'once' || s.often === 'twice'); }
  var FOR = { mission: 'trips', nano: 'your pocket', weekly: 'home' };
  var WHY = { mission: '3 pockets for trips and long weekends', nano: '1 pocket, an emergency stash', weekly: 'A full week at home, filled once' };
  // Bundle add-ons: the 2-Pack and 3-Pack builders take Weekly, Weekly AM-PM, 2-Week, Mission and Nano.
  function pair(id) {
    if (id === 'mission') return ['weekly', 'nano'];
    if (id === 'nano') return ['weekly', 'mission'];
    return s.where === 'travel' ? ['mission', 'nano'] : ['nano', 'mission'];
  }

  var s = { often: 'once', fill: 'week', where: 'home', q: [0, 0, 0, 0], b1: true, b2: false, on: { weekly: true, ampm: true, magnano: true, magampm: true, mission: true, nano: true, twoweek: false, fourweek: false } };

  /* ---------- data helpers ---------- */
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); }
  function vrec(p, zz) { var m = D.sizes[p.kind === 'magnano' ? p.h : p.h] || {}; return zz && zz.opt ? m[zz.opt] : null; }
  function priceOf(p, zz) {
    if (p.kind === 'variant') { var r = vrec(p, zz); return r ? r.price : null; }
    if (p.kind === 'magnano') { var v = D.magnanoSet[p.pockets + '|' + zz.set]; return v == null ? null : v; }
    var w = D.fourWeekSet[zz.set]; return w == null ? null : w;
  }
  function fromPrice(p) {
    var vals = [];
    if (p.kind === 'variant') { var m = D.sizes[p.h] || {}; for (var k in m) vals.push(m[k].price); }
    else if (p.kind === 'magnano') { for (var k2 in D.magnanoSet) if (k2.indexOf(p.pockets + '|') === 0) vals.push(D.magnanoSet[k2]); }
    else { for (var k3 in D.fourWeekSet) vals.push(D.fourWeekSet[k3]); }
    return vals.length ? Math.min.apply(null, vals) : null;
  }
  function availOf(p, zz) {
    if (p.kind === 'fourweek') return true; // the set builder shows its own stock
    var r = vrec(p, zz); return r ? r.available !== false : true;
  }
  function linkOf(p, zz) {
    var base = '/products/' + p.h;
    if (p.kind === 'magnano') return base + '?pockets=' + p.pockets + (zz ? '&size=' + zz.key : '');
    if (p.kind === 'fourweek') return base + '?count=4';
    var r = vrec(p, zz); return r ? base + '?variant=' + r.id : base;
  }
  function fullName(p, zz) {
    if (!zz) return p.name;
    if (p.id === 'magampm') return 'MagNano AM-PM ' + zz.n;
    if (p.kind === 'fourweek') return '4-Week ' + zz.n + ' Set';
    return zz.opt;
  }
  function qText(q) {
    var w = ['small', 'medium', 'large', 'XL'], out = [];
    for (var i = 3; i >= 0; i--) if (q[i]) out.push(q[i] + ' ' + w[i]);
    return out.join(', ');
  }
  function splitNames(p, sp) {
    return sp.a === sp.b ? '2 × ' + fullName(p, sp.a) : fullName(p, sp.a) + ' + ' + fullName(p, sp.b);
  }
  function splitLink(p, sp) {
    if (!p.bundle) return null;
    return '/products/2-pack-bundle?size1=' + lookupKey(sp.a.opt) + '&size2=' + lookupKey(sp.b.opt);
  }
  function lookupKey(t) { return String(t || '').trim().toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  /* ---------- fit ---------- */
  function total() { return s.q[0] + s.q[1] + s.q[2] + s.q[3]; }
  // Each pill uses 1/count of a pocket; a size fits when the shares add up to 1 or less.
  function fitsQ(cap, q) { var t = 0; for (var i = 0; i < 4; i++) { if (q[i]) t += q[i] / cap[i]; } return t <= 1 + 1e-9; }
  function fits(cap) { return fitsQ(cap, s.q); }
  // Name of a case's largest size with counts ('' when the case has none yet).
  function largest(id) { var l = SZ[id] || []; return l.length ? l[l.length - 1].n : ''; }
  // Dose too big for one pocket: fill the largest size first (biggest pills first),
  // then put what is left in the smallest size that holds it. Both pockets are checked
  // against the published counts, so a split is only offered when it truly fits.
  function splitFor(id) {
    var list = SZ[id] || [];
    if (!list.length) return null;
    var big = list[list.length - 1], a = [0, 0, 0, 0], left = s.q.slice();
    for (var i = 3; i >= 0; i--) {
      while (left[i] > 0) { a[i]++; if (fitsQ(big.cap, a)) left[i]--; else { a[i]--; break; } }
    }
    if (!fitsQ(big.cap, a)) return null;
    for (var k = 0; k < list.length; k++) if (fitsQ(list[k].cap, left)) return { a: big, qa: a, b: list[k], qb: left };
    return null;
  }
  function pickFor(id) {
    if (!total()) return { state: 'empty' };
    var list = SZ[id] || [];
    // A case with no counts in Case Specs is never given a fit: ask for a photo instead.
    if (!list.length) return { state: 'unknown' };
    for (var k = 0; k < list.length; k++) if (fits(list[k].cap)) return { state: 'fit', z: list[k] };
    // One bigger case beats two smaller ones: suggest it first when it holds the dose.
    var up = UP[id];
    if (up && pickFor(up).state === 'fit') return { state: (UNPUB[id] && UNPUB[id].length) ? 'unknown' : 'over' };
    var sp = splitFor(id);
    if (sp) return { state: 'split', sp: sp };
    return { state: (UNPUB[id] && UNPUB[id].length) ? 'unknown' : 'over' };
  }

  function matchId() {
    var twice = s.often === 'twice', home = s.where === 'home';
    if (s.often === 'needed') return s.where === 'travel' ? 'mission' : 'nano';
    if (s.often === 'thrice') return 'mission';
    if (s.fill === 'day') return twice ? 'mission' : 'nano';
    if (s.fill === 'two' && !twice) return 'twoweek';
    if (s.fill === 'month' && !twice) return 'fourweek';
    if (home) return twice ? 'ampm' : 'weekly';
    return twice ? 'magampm' : 'magnano';
  }
  function $(sel) { return root.querySelector(sel); }
  function img(p) { var u = D.img[p.h]; return u ? '<img src="' + esc(u) + '" alt="' + esc(p.name) + '" loading="lazy">' : ''; }

  /* ---------- pill icons (one matching set, growing Small to XL) ---------- */
  // [width, height, rx] in px at icon scale; the set grows visibly from Small to XL.
  // Drawn pills, one matching set. Proportions and colors follow the pills in our storage photos.
  var SHAPE = [[24, 24, 12], [51, 25, 12.5], [60, 32, 16], [80, 33, 16.5]];
  var FILL = [['#B0533B', '#7E3523'], ['#FFFFFF', '#B5B5B5'], ['#FBFBF8', '#B5B5B5'], ['#D9962A', '#9C6614']];
  function pillSvg(i, sc) {
    var w = SHAPE[i][0] * sc, h = SHAPE[i][1] * sc, r = SHAPE[i][2] * sc, pad = 2;
    var W = w + pad * 2, H = h + pad * 2, body;
    var f = FILL[i];
    body = '<rect x="' + pad + '" y="' + pad + '" width="' + w + '" height="' + h + '" rx="' + r + '" fill="' + f[0] + '" stroke="' + f[1] + '" stroke-width="1.2"/>' +
      (i === 3 ? '<rect x="' + (pad + w * 0.18) + '" y="' + (pad + h * 0.2) + '" width="' + (w * 0.32) + '" height="' + (h * 0.2) + '" rx="' + (h * 0.1) + '" fill="#fff" opacity=".55"/>' : '') +
      (i === 1 ? '<line x1="' + (pad + w / 2) + '" y1="' + (pad + h * 0.2) + '" x2="' + (pad + w / 2) + '" y2="' + (pad + h * 0.8) + '" stroke="#C8C8C8" stroke-width="1.2"/>' : '');
    return '<svg class="fyc-pill" width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" focusable="false">' + body + '</svg>';
  }
  function pic(i, sc) { return pillSvg(i, sc * 2); }
  function pileHtml() {
    var n = total(), shown = 0, out = '', cap = 40;
    for (var i = 3; i >= 0; i--) for (var k = 0; k < s.q[i]; k++) { if (shown < cap) out += pic(i, 0.25); shown++; }
    return out + (n > cap ? '<span class="fyc-pile__more">+' + (n - cap) + ' more</span>' : '');
  }

  /* ---------- renderers ---------- */
  function qHtml(q, no) {
    return '<fieldset class="fyc-q"><legend>' + no + '. ' + q[1] + '</legend><div class="fyc-opts">' + q[2].map(function (o) {
      return '<button type="button" class="fyc-opt" data-q="' + q[0] + '" data-v="' + o[0] + '" aria-pressed="' + (s[q[0]] === o[0]) + '">' + o[1] + '</button>';
    }).join('') + '</div></fieldset>';
  }
  function renderQuiz() {
    var no = 0;
    $('[data-fyc-questions]').innerHTML = Q.filter(function (q) { return asked(q[0]); }).map(function (q) { return qHtml(q, ++no); }).join('');
  }
  function renderMatch() {
    var m = BY[matchId()], r = pickFor(m.id), sized = r.state === 'fit';
    var priceTxt = m.unit ? ' · ' + m.unit : '';
    var fn = r.state === 'split' ? splitNames(m, r.sp) : fullName(m, sized ? r.z : null);
    $('[data-fyc-match]').innerHTML = '<p class="fyc-label">YOUR CASE</p>' + img(m) +
      '<p class="fyc-match__name">' + m.name + '</p><p class="fyc-match__line">' + m.line + '</p>' +
      '<p class="fyc-match__pick">' + (sized ? 'Your pick: ' : r.state === 'split' ? 'Your dose needs 2 cases: ' : 'Your pick, size to come: ') + '<strong>' + fn + '</strong>' + priceTxt + '</p>' +
      '<div class="fyc-btns"><a class="fyc-btn fyc-btn--dark" href="' + (r.state === 'split' ? (splitLink(m, r.sp) || '#fyc-size') : linkOf(m, sized ? r.z : null)) + '">' + (r.state === 'split' ? (splitLink(m, r.sp) ? 'Build my 2-Pack' : 'See your 2 cases ↓') : 'Shop ' + fn) + '</a>' +
      '<button type="button" class="fyc-btn fyc-btn--light" data-add="' + m.id + '">' + (s.on[m.id] ? 'In compare ✓' : 'Add to compare') + '</button></div>' +
      '<a class="fyc-under" href="#fyc-size">' + (sized ? 'Change your pills ↓' : 'Next: find your size ↓') + '</a>';
  }
  function stepperHtml(i) {
    var n = s.q[i];
    return '<div class="fyc-ps" data-pi="' + i + '"><div class="fyc-ps__icon">' + pic(i, 0.5) + '</div>' +
      '<p class="fyc-ps__name">' + PILL[i][0] + '<span class="fyc-ps__hint">' + PILL[i][1] + '</span></p>' +
      '<div class="fyc-ps__step"><button type="button" class="fyc-ps__b" data-pd="' + i + '" data-d="-1" aria-label="One fewer ' + PILL[i][0].toLowerCase() + ' pill"' + (n ? '' : ' disabled') + '>−</button>' +
      '<span class="fyc-ps__n" aria-live="polite">' + n + '</span>' +
      '<button type="button" class="fyc-ps__b" data-pd="' + i + '" data-d="1" aria-label="One more ' + PILL[i][0].toLowerCase() + ' pill"' + (n < MAXQ ? '' : ' disabled') + '>+</button></div></div>';
  }
  function resultHtml(m, r) {
    var h = '<p class="fyc-label">YOUR SIZE</p>';
    if (r.state === 'empty') return h + '<p class="fyc-res__prompt">Add the pills in your biggest dose</p><p class="fyc-res__sub">Your size for the ' + m.name + ' shows here.</p>';
    if (r.state === 'fit') {
      var av = availOf(m, r.z);
      h += '<p class="fyc-res__size">' + r.z.n + '</p><p class="fyc-res__sub"><strong>' + fullName(m, r.z) + '</strong>' + (m.unit ? ' · ' + m.unit : '') + '</p>' +
        '<p class="fyc-res__fit">Your dose fits in one pocket.</p>' +
        (av ? '' : '<p class="fyc-res__out">This size is sold out right now. You can sign up to hear when it is back.</p>') +
        (m.kind === 'fourweek' ? '<p class="fyc-res__fit">Pick the ' + r.z.n + ' size on the next page.</p>' : '') +
        '<div class="fyc-btns fyc-btns--one"><a class="fyc-btn fyc-btn--dark" href="' + linkOf(m, r.z) + '">' + (av ? 'Shop ' : 'See ') + fullName(m, r.z) + '</a></div>';
      return h;
    }
    if (r.state === 'split') {
      var sp = r.sp, bl = splitLink(m, sp);
      h += '<p class="fyc-res__prompt">Your dose needs 2 pockets</p><p class="fyc-res__sub">It is more than one ' + fullName(m, sp.a) + ' pocket holds, so split it across 2 cases.</p>' +
        '<ul class="fyc-split"><li><strong>' + fullName(m, sp.a) + '</strong><span>' + qText(sp.qa) + '</span></li><li><strong>' + fullName(m, sp.b) + '</strong><span>' + qText(sp.qb) + '</span></li></ul>' +
        (bl ? '<div class="fyc-btns fyc-btns--one"><a class="fyc-btn fyc-btn--dark" href="' + bl + '">Build my 2-Pack</a></div><p class="fyc-res__fit">Both sizes come filled in on the 2-Pack, with bundle savings.</p>'
            : '<div class="fyc-btns fyc-btns--one"><a class="fyc-btn fyc-btn--dark" href="' + linkOf(m, sp.a) + '">Shop ' + fullName(m, sp.a) + '</a>' + (sp.b !== sp.a ? '<a class="fyc-btn fyc-btn--light" href="' + linkOf(m, sp.b) + '">Shop ' + fullName(m, sp.b) + '</a>' : '') + '</div>' + (sp.b === sp.a ? '<p class="fyc-res__fit">Buy 2.</p>' : ''));
      return h + '<a class="fyc-under" href="/pages/contact-us">Send us a photo of your pills</a>';
    }
    var up = UP[m.id] && BY[UP[m.id]], ur = up ? pickFor(up.id) : null;
    if (r.state === 'unknown') {
      h += '<p class="fyc-res__prompt">Send us a photo</p><p class="fyc-res__sub">' + (largest(m.id) ? 'Your dose is more than a ' + m.name + ' ' + largest(m.id) + ' pocket holds. It also comes in ' + (UNPUB[m.id] || []).join(' and ') + '; send' : 'Send') + ' us a photo of your pills and we\'ll tell you if it fits.</p>';
    } else if (ur && ur.state === 'fit') {
      h += '<p class="fyc-res__prompt">Too big for one ' + m.name + ' pocket</p><p class="fyc-res__sub">Your dose is more than the largest ' + m.name + ' pocket (' + largest(m.id) + ') holds. One bigger case fits it.</p>';
    } else {
      h += '<p class="fyc-res__prompt">Too big for 2 pockets</p><p class="fyc-res__sub">Your dose is more than 2 of the largest ' + m.name + ' pockets hold. Send us a photo and we\'ll help you plan it.</p>';
    }
    if (ur && ur.state === 'fit') h += '<p class="fyc-res__fit">A ' + up.name + ' in ' + ur.z.n + ' holds it.</p><div class="fyc-btns fyc-btns--one"><a class="fyc-btn fyc-btn--dark" href="' + linkOf(up, ur.z) + '">Shop ' + up.name + ' ' + ur.z.n + '</a></div>';
    return h + '<a class="fyc-under" href="/pages/contact-us">Send us a photo of your pills</a>';
  }
  function renderSizeBox() {
    var m = BY[matchId()], r = pickFor(m.id), n = total();
    var steppers = '<div class="fyc-steppers">' + [0, 1, 2, 3].map(stepperHtml).join('') + '</div>';
    var pile = '<div class="fyc-dose"><p class="fyc-dose__t">' + (n ? 'Your dose: <strong>' + n + ' ' + (n === 1 ? 'pill' : 'pills') + '</strong>' : 'Your dose: no pills yet') + '</p>' +
      '<div class="fyc-pile" aria-hidden="true">' + (n ? pileHtml() : '') + '</div>' +
      (n ? '<button type="button" class="fyc-clear" data-clear>Start over</button>' : '') + '</div>';
    $('[data-fyc-sizebox]').innerHTML = '<div class="fyc-sizein"><p class="fyc-sizein__t">How many of each pill do you take at once?</p>' + steppers + pile + '</div>' +
      '<div class="fyc-res fyc-match" aria-live="polite">' + resultHtml(m, r) + '</div>';
  }
  function renderSizes() {
    var m = BY[matchId()], list = SZ[m.id] || [], r = pickFor(m.id), pick = r.state === 'fit' ? r.z.n : null;
    var h = '<p class="fyc-ladder">' + m.name + ' sizes · pills per pocket</p>' +
      '<div class="fyc-cap" role="table" aria-label="' + esc(m.name) + ' pills per pocket by size"><div class="fyc-cap__r fyc-cap__h" role="row"><span role="columnheader">Size</span>' +
      PILL.map(function (p) { return '<span role="columnheader">' + p[0] + '</span>'; }).join('') + '</div>';
    list.forEach(function (q) {
      var on = q.n === pick;
      h += '<div class="fyc-cap__r' + (on ? ' is-on' : '') + '" role="row"><span role="cell"><strong>' + q.n + '</strong>' + (on ? '<em>Your size</em>' : '') + '</span>' +
        q.cap.map(function (v, i) { return '<span role="cell"' + (s.q[i] ? ' class="is-col"' : '') + '>' + v + '</span>'; }).join('') + '</div>';
    });
    h += '</div><p class="fyc-cap__note">Pills per pocket, by pill size. ' + PILL.map(function (p) { return p[0] + ': ' + p[1]; }).join(' · ') + '.</p>';
    if (UNPUB[m.id]) h += '<p class="fyc-cap__note">Also comes in ' + UNPUB[m.id].join(' and ') + '. <a href="/pages/contact-us">Send us a photo of your pills</a> and we\'ll tell you if it fits.</p>';
    $('[data-fyc-sizes]').innerHTML = h;
  }
  function renderBundle() {
    var m = BY[matchId()], box = $('[data-fyc-bundle]');
    box.hidden = !m.bundle;
    if (!m.bundle) { box.innerHTML = ''; return; }
    var c = pair(m.id).map(function (id) { return BY[id]; });
    var all = [m, c[0], c[1]], sel = [true, s.b1, s.b2];
    var info = all.map(function (p) { var r = pickFor(p.id); return { p: p, z: r.state === 'fit' ? r.z : null }; });
    var chosen = info.filter(function (x, i) { return sel[i]; });
    var n = chosen.length, anyFrom = false;
    var sum = chosen.reduce(function (t, x) { var v = x.z ? priceOf(x.p, x.z) : (anyFrom = true, fromPrice(x.p)); return t + (v || 0); }, 0);
    var tiles = info.map(function (x, i) {
      var o = sel[i], pr = x.z ? priceOf(x.p, x.z) : fromPrice(x.p);
      return '<button type="button" class="fyc-tile" aria-pressed="' + o + '"' + (i === 0 ? ' data-locked aria-disabled="true"' : ' data-b="' + i + '"') + '>' +
        '<span class="fyc-tile__tag">' + (i === 0 ? 'YOUR MATCH' : (o ? 'ADDED' : 'TAP TO ADD')) + '</span><span class="fyc-box" aria-hidden="true">✓</span>' +
        img(x.p) + '<span class="fyc-tile__name">' + x.p.name + '</span><span class="fyc-tile__why">' + (i === 0 ? x.p.line : WHY[x.p.id]) + '</span>' +
        '<span class="fyc-tile__price">' + (x.z ? x.z.n + ' · ' : '') + (pr == null ? '' : (x.z ? '' : 'from ') + money(pr)) + '</span></button>';
    }).join('');
    var qs = chosen.map(function (x, i) { return x.z ? 'size' + (i + 1) + '=' + lookupKey(x.z.opt) : ''; }).filter(Boolean).join('&');
    var href = '/products/' + n + '-pack-bundle' + (qs ? '?' + qs : '');
    var line = n < 2 ? 'Add one more case to unlock bundle savings.' :
      (n === 2 ? '2-Pack' : '3-Pack') + ': ' + chosen.map(function (x) { return x.p.name + (x.z ? ' ' + x.z.n : ''); }).join(' + ') + ' · ' + (anyFrom ? 'from ' : '') + money(sum) + ' before bundle savings';
    var cta = n < 2 ? '<a class="fyc-cta fyc-cta--ghost" href="' + linkOf(m, info[0].z) + '">Shop ' + m.name + ' only</a>' : '<a class="fyc-cta" href="' + href + '">Build my ' + n + '-Pack</a>';
    box.innerHTML = '<div class="fyc-bundle__top"><div><p class="fyc-label">COMPLETE YOUR SET</p><h2>Pair your ' + m.name + ' with cases for ' + FOR[c[0].id] + ' and ' + FOR[c[1].id] + '</h2></div>' +
      '<p class="fyc-bundle__help">' + bundleHelp() + '</p></div>' +
      '<div class="fyc-tiles">' + tiles + '</div><div class="fyc-bundle__foot"><p class="fyc-bundle__sum">' + line + '</p>' + cta + '</div>';
  }
  // Savings come from the bundle products' "Bundle: save up to" metafields (FYC_DATA.bundleSave), never typed here.
  function bundleHelp() {
    var bs = D.bundleSave || {}, parts = [];
    if (bs['2']) parts.push('Pick any 2, save up to ' + money(bs['2']) + '.');
    if (bs['3']) parts.push('Pick any 3, save up to ' + money(bs['3']) + '.');
    parts.push('Tap a case to add or remove it.');
    return parts.join(' ');
  }
  function compareCell(p, key) {
    var r = pickFor(p.id);
    if (key === 'yoursize') return r.state === 'fit' ? r.z.n : r.state === 'empty' ? 'Add your pills above' : r.state === 'split' ? (r.sp.a === r.sp.b ? '2 × ' + r.sp.a.n : r.sp.a.n + ' + ' + r.sp.b.n) : 'Send us a photo';
    if (key === 'price') { var v = r.state === 'fit' ? priceOf(p, r.z) : fromPrice(p); return v == null ? '' : (r.state === 'fit' ? '' : 'from ') + money(v) + (p.unit ? ' · ' + p.unit : ''); }
    return p[key];
  }
  var KEYS = [['Your size', 'yoursize'], ['Price', 'price'], ['How often', 'often'], ['Case type', 'type'], ['Holds', 'holds'], ['Sizes', 'sizes'], ['Best for', 'best']];
  function renderCompare() {
    $('[data-fyc-cchips]').innerHTML = P.map(function (p) {
      var c = !!s.on[p.id];
      return '<label class="fyc-cchip' + (c ? ' is-on' : '') + '"><input type="checkbox" data-c="' + p.id + '"' + (c ? ' checked' : '') + '>' + p.name + '</label>';
    }).join('');
    var picked = P.filter(function (p) { return s.on[p.id]; }), two = picked.length === 2;
    $('[data-fyc-two]').hidden = !two;
    var t = $('[data-fyc-table]');
    t.style.setProperty('--n', Math.max(picked.length, 1));
    if (!picked.length) { t.innerHTML = '<p class="fyc-empty">Check a case above to compare it.</p>'; return; }
    var h = '<div class="fyc-row"><div></div>' + picked.map(function (p) { return '<div class="fyc-col">' + img(p) + '<span>' + p.name + '</span></div>'; }).join('') + '</div>';
    KEYS.forEach(function (k) {
      var vals = picked.map(function (p) { return compareCell(p, k[1]); });
      var diff = two && vals[0] !== vals[1];
      h += '<div class="fyc-row"><div class="fyc-rl">' + k[0] + '</div>' + vals.map(function (v) { return '<div class="fyc-cell' + (diff ? ' is-diff' : '') + '">' + v + '</div>'; }).join('') + '</div>';
    });
    h += '<div class="fyc-row"><div></div>' + picked.map(function (p) { var r = pickFor(p.id); return '<a class="fyc-shop" href="' + linkOf(p, r.state === 'fit' ? r.z : null) + '">Shop</a>'; }).join('') + '</div>';
    t.innerHTML = h;
  }
  function afterPills() { renderSizeBox(); renderMatch(); renderSizes(); renderBundle(); renderCompare(); }
  function all() { renderQuiz(); afterPills(); }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.dataset.pd) {
      var i = +b.dataset.pd, d = +b.dataset.d;
      s.q[i] = Math.max(0, Math.min(MAXQ, s.q[i] + d)); afterPills();
      var nb = root.querySelector('.fyc-ps__b[data-pd="' + i + '"][data-d="' + d + '"]');
      if (nb && !nb.disabled) nb.focus(); else { var ob = root.querySelector('.fyc-ps__b[data-pd="' + i + '"]:not([disabled])'); if (ob) ob.focus(); }
    } else if (b.hasAttribute('data-clear')) {
      s.q = [0, 0, 0, 0]; afterPills(); var f = root.querySelector('.fyc-ps__b[data-d="1"]'); if (f) f.focus();
    } else if (b.dataset.q) {
      s[b.dataset.q] = b.dataset.v; s.b1 = true; s.b2 = false;
      all();
      var nq = root.querySelector('.fyc-opt[data-q="' + b.dataset.q + '"][data-v="' + b.dataset.v + '"]'); if (nq) nq.focus();
    } else if (b.dataset.add) {
      s.on[b.dataset.add] = true; renderMatch(); renderCompare();
    } else if (b.dataset.b) {
      var k = 'b' + b.dataset.b; s[k] = !s[k]; renderBundle();
      var nt = root.querySelector('.fyc-tile[data-b="' + b.dataset.b + '"]'); if (nt) nt.focus();
    }
  });
  root.addEventListener('change', function (e) {
    var id = e.target.dataset && e.target.dataset.c;
    if (!id) return;
    s.on[id] = e.target.checked; renderMatch(); renderCompare();
    var ni = root.querySelector('input[data-c="' + id + '"]'); if (ni) ni.focus();
  });
  // Test hook for the QC sweep (read-only).
  window.__fyc = { splitFor: splitFor, fitsQ: fitsQ, fullName: fullName, s: s, SZ: SZ, UNPUB: UNPUB, BY: BY, matchId: matchId, pickFor: pickFor, priceOf: priceOf, linkOf: linkOf, render: all };
  all();
})();
